import { useT } from '@hana/i18n';
import { KPI_PEOPLE, fi } from './kpiPeople';
import d from './kpiDept.module.css';
import s from './kpiClose.module.css';

// Mint-KPI · tab Chốt kỳ (code board: tab === 'close'). Kỳ Oct/2026 đang mở. Chỉ đọc; không tiền.

type Tone = 'ok' | 'warn' | 'pri' | 'none';
const TONE: Record<Tone, [string, string]> = { ok: ['var(--ok-bg)', 'var(--ok)'], warn: ['var(--warn-bg)', 'var(--warn)'], pri: ['var(--pri-bg)', 'var(--link)'], none: ['var(--sub)', 'var(--tx2)'] };
const MON = ['May/2026', 'Jun/2026', 'Jul/2026', 'Aug/2026', 'Sep/2026', 'Oct/2026'];
const ARC = 'M 15 95 A 80 80 0 0 1 175 95';

function Chip({ tone, children }: { tone: Tone; children: string }) {
  return <span className={s.chip} style={{ background: TONE[tone][0], color: TONE[tone][1] }}>{children}</span>;
}

function Gauge({ k, pct, v, sub, color }: { k: string; pct: number; v: string; sub: string; color: string }) {
  const off = (251.3 * (1 - Math.min(Math.max(pct, 0), 100) / 100)).toFixed(1);
  return (
    <div className={s.gauge}>
      <svg role="img" aria-label={`${k}: ${v} · ${sub}`} width="190" height="104" viewBox="0 0 190 104">
        <path d={ARC} fill="none" stroke="var(--skel)" strokeWidth="14" strokeLinecap="round" />
        <path d={ARC} fill="none" stroke={color} strokeWidth="14" strokeLinecap="round" strokeDasharray="251.3 251.3" strokeDashoffset={off} />
        <text x="95" y="82" textAnchor="middle" fontSize="26" fontWeight="550" fill="var(--tx)" fontFamily="Inter, system-ui, sans-serif">{v}</text>
      </svg>
      <b>{k}</b>
      <span>{sub}</span>
    </div>
  );
}

export function HrKpiClose() {
  const t = useT();
  const people = KPI_PEOPLE.length;
  const scored = KPI_PEOPLE.filter((p) => p.fin != null).length;
  const [done, total] = [17, 30];
  const waitEv = 4;
  const sheetWarn = done < total;
  const before: { tone: Tone; chip: string; k: string; v: string }[] = [
    { tone: sheetWarn ? 'warn' : 'ok', chip: sheetWarn ? t('hr.kc.short') : t('hr.kc.enough'), v: `${done} / ${total}`, k: t('hr.kc.timesheet') },
    { tone: waitEv ? 'warn' : 'ok', chip: waitEv ? t('hr.kc.left') : t('hr.kc.done'), v: t('hr.kc.cases', { n: waitEv }), k: t('hr.kc.pendingEv') },
    { tone: 'ok', chip: t('hr.kc.done'), v: t('hr.kc.loaded'), k: t('hr.kc.actionMark') },
    { tone: 'warn', chip: t('hr.kc.wait'), v: t('hr.kc.notSet'), k: t('hr.kc.coTarget') },
  ];
  return (
    <div className={d.grid}>
      <section className={d.tiles} aria-label={t('hr.kc.metrics')}>
        <div className={d.tile}><span>{t('hr.kc.period')}</span><b>Oct/2026</b><span>{t('hr.kc.openRecalc')}</span></div>
        <div className={d.tile}><span>{t('hr.kc.staffInPeriod')}</span><b>{fi(people)}</b><span>{t('hr.kc.scoredN', { n: scored })}</span></div>
        <div className={d.tile}><span>{t('hr.kc.sheetsHave')}</span><b style={{ color: sheetWarn ? 'var(--warn)' : 'var(--ok)' }}>{done} / {total}</b><span>TblTimesheetMonth</span></div>
        <div className={d.tile}><span>{t('hr.kc.openCases')}</span><b style={{ color: waitEv ? 'var(--warn)' : undefined }}>{fi(waitEv)}</b><span>{t('hr.kc.notEffNoCount')}</span></div>
      </section>
      <section className={d.panel} aria-label={t('hr.kc.readiness')}>
        <div className={d.hd}><h2>{t('hr.kc.readiness')}</h2><span>{t('hr.kc.readinessSub')}</span></div>
        <div className={s.gauges}>
          <Gauge k={t('hr.kc.timesheet')} pct={(done / total) * 100} v={`${done} / ${total}`} sub="TblTimesheetMonth" color={sheetWarn ? 'var(--d-amber)' : 'var(--ok)'} />
          <Gauge k={t('hr.kc.staffScored')} pct={(scored / (people || 1)) * 100} v={`${scored} / ${people}`} sub={t('hr.kc.noMetricSet', { n: people - scored })} color="var(--d-blue)" />
        </div>
      </section>
      <div className={s.two}>
        <section className={d.panel} aria-label={t('hr.kc.before')}>
          <div className={d.hd}><h2>{t('hr.kc.before')}</h2><span>{t('hr.kc.noRecalc')}</span></div>
          <div>
            {before.map((b) => (
              <div key={b.k} className={s.row}><Chip tone={b.tone}>{b.chip}</Chip><span className={s.k}>{b.k}</span><b className={s.v}>{b.v}</b></div>
            ))}
          </div>
        </section>
        <section className={d.panel} aria-label={t('hr.kc.who')}>
          <div className={d.hd}><h2>{t('hr.kc.who')}</h2><span>{t('hr.kc.bySeat')}</span></div>
          <div>
            <div className={s.row}><span className={s.k}>{t('hr.kc.closer')}</span><b className={s.v}>[BOD-DIR] PHILIP</b></div>
            <div className={s.row}><span className={s.k}>{t('hr.kc.proxy')}<small>{t('hr.kc.proxySub')}</small></span><b className={s.v}>{t('hr.kc.proxyNo')}</b></div>
            <div className={s.row}><span className={s.k}>{t('hr.kc.writeTo')}<small>{t('hr.kc.noData')}</small></span><b className={s.v}>TblKPIScore</b></div>
          </div>
        </section>
      </div>
      <section className={d.panel} aria-label={t('hr.kc.periods')}>
        <div className={d.hd}><h2>{t('hr.kc.periods')}</h2><span>{t('hr.kc.noneClosed')}</span></div>
        <table className={d.tbl} aria-label={t('hr.kc.periods')}>
          <colgroup>{['20%', '18%', '24%', '20%', '18%'].map((w, i) => <col key={i} style={{ width: w }} />)}</colgroup>
          <thead><tr><th scope="col">{t('hr.kc.period')}</th><th scope="col">{t('hr.kc.status')}</th><th scope="col">{t('hr.kc.closedBy')}</th><th scope="col">{t('hr.kc.closedOn')}</th><th scope="col" className={d.r}>{t('hr.kc.headcount')}</th></tr></thead>
          <tbody>
            {[...MON].reverse().map((m, i) => {
              const open = i === 0;
              return (
                <tr key={m} className={open ? s.sel : undefined}>
                  <td className={d.sc}>{m}</td>
                  <td><Chip tone={open ? 'pri' : 'none'}>{open ? t('hr.kc.live') : t('hr.kc.notClosed')}</Chip></td>
                  <td className={d.seat}>—</td><td className={d.none}>—</td><td className={d.r}>—</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </div>
  );
}
